"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featuredCanisters = void 0;
exports.featuredCanisters = [
    'j3dqa-byaaa-aaaah-qcwfa-cai',
    'gtb2b-tiaaa-aaaah-qcxca-cai',
    '3vdxu-laaaa-aaaah-abqxa-cai',
    '4fcza-biaaa-aaaah-abi4q-cai',
];
